import {
    GET_ALL_RT_TAX_TYPE,
    SET_ALL_RT_TAX_TYPE,
    POST_RT_TAX_TYPE,
    PUT_RT_TAX_TYPE,
    DELETE_RT_TAX_TYPE
} from '../../constants';
import { errorNotification, successNotification } from "../../../../utils/notification";
import { FINANCIAL_RT_ENDPOINT } from '../../constants/endpoint';
import { onError, onSuccess } from '../../../../utils/http';

export const getAllTaxType = () => {
    return {
        type: GET_ALL_RT_TAX_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/taxType`
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                store.dispatch(setAllTaxType(response.data));
                return response;
            })
        }
    };
};

export const setAllTaxType = (data) => {
    return {
        type: SET_ALL_RT_TAX_TYPE,
        payload: data
    };
};

export const postTaxType = (taxType) => {
    return {
        type: POST_RT_TAX_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/taxType`,
            method: 'post',
            data: taxType
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "create_success");
                store.dispatch(getAllTaxType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "create_error");
                throw error;
            })
        }
    };
};

export const putTaxType = (id, taxType) => {
    return {
        type: PUT_RT_TAX_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/taxType/${id}`,
            method: 'put',
            data: taxType
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "update_success");
                store.dispatch(getAllTaxType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "update_error");
                throw error;
            })
        }
    };
};

export const deleteTaxType = (id) => {
    return {
        type: DELETE_RT_TAX_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/taxType/${id}`,
            method: 'delete'
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "delete_success");
                store.dispatch(getAllTaxType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', error.response.status === 409 ? "ressource_in_use_error" : "delete_error");
                throw error;
            })
        }
    };
};